const BlockView = require('views/block/base-block-view');
const LocaleService = require('services/locale-service');
const CourseSettingsService = require('services/course-settings-service');
const DOMPurify = require('dompurify');

const LocaleSelectorView = BlockView.extend({
  initialize: function () {
    BlockView.prototype.initialize.apply(this, arguments);
    const currLang = LocaleService.getLanguage();
    const languageList = CourseSettingsService.get('supported_languages').filter(l => l !== 'cimode');
    const languageOptions = languageList.map(lang => {
      return {
        code: lang,
        text: LocaleService.t(`languages.${lang}`),
        selected: lang === currLang,
      };
    });
    this.model.set('languages', languageOptions);
  },
  load: function () {
    this.delegate('change', '#locale-selector', function (e) {
      if (this.model.has('languages') && this.model.get('languages').some(lang => lang.code === e.target.value)) {
        let { origin, pathname, search, hash } = window.location;
        origin = DOMPurify.sanitize(origin);
        pathname = DOMPurify.sanitize(pathname);
        search = DOMPurify.sanitize(search);
        hash = DOMPurify.sanitize(hash);
        const pattern = new RegExp('\\b(setLng=).*?(&|#|$)');
        let newSearch;
        if (search.search(pattern) >= 0) {
          newSearch = search.replace(pattern, '$1' + e.target.value + '$2');
        } else {
          newSearch = `${search}${search.indexOf('?') >= 0 ? '&' : '?'}setLng=${e.target.value}`;
        }
        window.location = DOMPurify.sanitize(encodeURI(`${origin}${pathname}${newSearch}${hash}`));
      }
    });
  },
  play: function () {
    this.readyToGo();
  },
});

module.exports = LocaleSelectorView;
